/* eslint-disable react/require-default-props */

import CameraIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/camera';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import STYLES from './ImageInfo.module.scss';

type Props = {
  location?: string;
  description?: string;
  credit?: string;
};

const ImageInfo = ({ credit, description, location }: Props) => (
  <div className={STYLES.imageInfo}>
    <div>
      {location && <BpkText textStyle={TEXT_STYLES.label3}>{location}</BpkText>}{' '}
      {description && (
        <BpkText textStyle={TEXT_STYLES.xs}>{description}</BpkText>
      )}
    </div>
    {credit && (
      <div className={STYLES.credit} aria-label={credit}>
        <CameraIcon aria-hidden className={STYLES.creditIcon} />
        <BpkText textStyle={TEXT_STYLES.xs} aria-hidden>
          {credit}
        </BpkText>
      </div>
    )}
  </div>
);

export default ImageInfo;
